export default __webpack_public_path__ + "static/media/who-we-are-img-06.85a6793f.jpg";